import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onMounted } from "vue";
import { AuthenticationListItemProps } from "@/types";
import { integrationsStore, jiraApiStore } from "@/hooks";
import AuthenticationListItem from "./AuthenticationListItem.vue";


/**
 * Prompts the user to authenticate their Jira account.
 */
const __default__ = {
  name: "JiraAuthentication",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    inactive: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const hasCredentials = computed(() => integrationsStore.validJiraCredentials);

onMounted(() => {
  jiraApiStore.handleVerifyCredentials();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AuthenticationListItem, {
    title: "Jira",
    loading: _unref(jiraApiStore).loading,
    "has-credentials": hasCredentials.value,
    inactive: props.inactive,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click'))),
    onConnect: _unref(jiraApiStore).handleAuthRedirect,
    onDisconnect: _unref(jiraApiStore).handleDeleteCredentials
  }, null, 8, ["loading", "has-credentials", "inactive", "onConnect", "onDisconnect"]))
}
}

})